import queryString from 'query-string'

/**
 * Serialize an args object to a query string, dropping empty params so we don't
 * send `?query=` noise. Shared by the RTK Query API modules (bundles, search,
 * standalone courses) so the empty-param rule stays identical across them.
 */
export const toQueryString = (args: Record<string, unknown>) => {
	const clean = Object.fromEntries(Object.entries(args).filter(([, v]) => v !== undefined && v !== null && v !== ''))
	return queryString.stringify(clean)
}

export default toQueryString
